import {
  SlInclude
} from "./chunk.ODM3674Z.js";

// src/components/include/include.ts
var include_default = SlInclude;
SlInclude.define("sl-include");

export {
  include_default
};
